import {
  addressWithUnitNumber,
  AdminHeader,
  AdminOptionsDropdown,
  AdminSpinner,
  AllProvidersModal,
  ArrowRed,
  EDIT_LOCATION_PARAM,
  Box,
  Brand,
  ClosingDaysPageIcon,
  CopyTextWithIcon,
  DeliveriesIcon,
  Disclaimer,
  Div,
  DragScrollX,
  DropdownCommissionsIcon,
  DropdownDeleteIcon,
  DropdownLocationIcon,
  DropdownMenuIcon,
  DropdownNotesIcon,
  DropdownAccessIcon,
  DropdownProvidersIcon,
  DropdownSyncIcon,
  DropdownVDriveIcon,
  EditPenIconRed,
  describePayoutConfig,
  ensurePayoutConfigs,
  H3,
  H5,
  Icon,
  IntegrationAccessModal,
  PaperPlaneIcon,
  isPayoutServiceVisible,
  OrderIcon,
  P,
  PayoutConfigModal,
  PayoutConfigResponse,
  payoutModelLabel,
  payoutServiceLabel,
  PhoneNumberText,
  Pill,
  PlusIcon,
  RecoverIcon,
  RenderProviderStatus,
  SuccessToast,
  TaxRatesIcon,
  WorkingHoursIcon,
  getLocationById,
  getLocationProviderStatuses,
  lightTheme,
  queryKeys,
  reportError,
  setTimeTo,
  showStringIfNotNull,
  syncLocationProviders,
  useAuthenticatedAuthUser,
} from '@vgrubs/components';
import { useInvalidateQueries } from 'components/src/hooks/useInvalidateQueries';
import {
  IncompleteLocation,
  ProviderAndProviderStatusResponse,
} from 'components/src/types/api/location.types';
import {
  LocationEntity,
  LocationMode,
  Owner,
} from 'components/src/types/location.types';
import { VDriveStatus } from 'components/src/types/shared.types';
import { useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { ImageWithDownload } from '../../../../../components/src/adminPages/Settings/ImageInput';
import { AllProvidersModalComponent } from '../../../../../components/src/shared/dashboard/AllProvidersModalComponent';
import { UsersAndAccessDetailsModal } from '../UsersAndAccess/UsersAndAccessDetails';
import { BankEdit } from './BankEdit';
import styled from 'styled-components';
import { BrandAddModal } from './BrandAdd';
import { BrandAddSuccessModal } from './BrandAddSuccess';
import { BrandLocationComponent } from './BrandLocationComponent';
import { BrandNoteModal } from './BrandNoteModal';
import {
  ChangeLocationAddress,
  ChangeLocationAddressConfirm,
} from './ChangeLocationAddress';
import { DeleteLocationBrandModal } from './DeleteLocationBrandModal';
import { LocationAnalyticsSection } from './LocationAnalyticsSection';
import { LocationEdit } from './LocationEdit';
import { LocationImage } from './LocationImage';
import { TemplateBrandAdd } from './TemplateBrandAdd';
import { LocationRecoverModal } from './components/LocationRecover';
import { LocationReferralInfo } from './components/LocationReferralInfo';
import { OutstandingBalanceBanner } from './components/OutstandingBalanceBanner';
import { LocationPrinters } from '../SystemProblems';
import { LocationProblems } from './insights';
import { AmountComponent } from './components/AmountComponent';
import { AmountsPanel } from './components/AmountsPanel';
import { AmountsAside, AmountsMain } from './components/AmountsPanel.styled';
import { ProviderCommissionsModal } from './components/ProviderCommissionsModal';
import { LocationTaxRatesModal } from './taxRates/LocationTaxRatesModal';
import { LocationTaxRatesSummary } from './taxRates/LocationTaxRatesSummary';
import { MenuHealthReportsModal } from './menuHealth/MenuHealthReportsModal';
import { MenulyticsMark } from './menuHealth/components/MenulyticsMark';
import { SendTrackingSmsModal } from './SendTrackingSmsModal';
import { Earnings } from './earnings/Earnings';
import { useLocationAgents } from './earnings/useLocationAgents';
import { Services } from './services/Services';

export const LocationDetails = () => {
  const navigate = useNavigate();

  const today = new Date();
  const [loading, setLoading] = useState(false);
  const { id } = useParams() as { id: string };
  const [editLocationModal, setEditLocationModal] = useState(false);
  const [editBankModal, setEditBankModal] = useState(false);
  const [addBrandModal, setAddBrandModal] = useState(false);
  const [addBrandSuccessModal, setAddBrandSuccessModal] =
    useState<Brand | null>(null);
  const [noteModal, setNoteModal] = useState(false);
  const [integrationModal, setIntegrationModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState<string | null>(null);
  const [providerCommissions, setProviderCommissions] = useState(false);
  const [taxRatesModal, setTaxRatesModal] = useState(false);
  const [statuses, setStatuses] = useState<ProviderAndProviderStatusResponse>(
    []
  );
  const [data, setData] = useState<LocationEntity | null>(null);
  const [date, setDate] = useState([today, today]);
  const [dateInput, setDateInput] = useState<Date[] | string[]>([today, today]);
  const [userDetailsModal, setUserDetailsModal] = useState<Owner | null>(null);
  const [allProvidersModal, setAllProvidersModal] =
    useState<AllProvidersModal | null>(null);
  const [brandTemplates, setBrandTemplates] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();

  /* A notification about the location's ACH customer links here with
     `?editLocation=1`: Edit Location holds the ACH Customer ID. Opened once
     the location is in, and the flag dropped so Back does not reopen it. */
  const editLocationRequested = searchParams.has(EDIT_LOCATION_PARAM);
  useEffect(() => {
    if (!editLocationRequested || !data) return;
    if (!data.deleted) setEditLocationModal(true);
    searchParams.delete(EDIT_LOCATION_PARAM);
    setSearchParams(searchParams, { replace: true });
  }, [editLocationRequested, data]);

  const [changeAddressModal, setChangeAddressModal] = useState(false);
  const [confirmAddressModal, setConfirmAddressModal] =
    useState<IncompleteLocation | null>(null);

  const [payoutConfigModal, setPayoutConfigModal] =
    useState<PayoutConfigResponse | null>(null);

  const [recoverModal, setRecoverModal] = useState<LocationEntity | null>(null);
  const [trackingSmsModal, setTrackingSmsModal] = useState(false);
  const [menuHealthModal, setMenuHealthModal] = useState(false);

  const { role } = useAuthenticatedAuthUser();

  const dateFrom = new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  }).format(date[0]);

  const dateTo = new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  }).format(date[1]);

  const handleDateChange = (date: Date[] | string[]) => {
    setDateInput(date);
  };

  const handleDateApply = () => {
    if (dateInput.length < 2) {
      setDate([dateInput[0], dateInput[0]] as Date[]);
      setDateInput([dateInput[0], dateInput[0]] as Date[]);
    } else {
      setDate(dateInput as Date[]);
    }
  };

  async function getLocationDetails(silent = false) {
    try {
      if (!silent) {
        setLoading(true);
      }
      const { data } = await getLocationById(id, {
        from: setTimeTo(date[0], 'start').toString(),
        to: setTimeTo(date[1], 'end').toString(),
      });
      setData(data.data);
    } catch (error) {
      reportError(error);
    } finally {
      setLoading(false);
    }
  }

  async function syncProviders() {
    try {
      setLoading(true);
      const { data } = await syncLocationProviders(id);
      SuccessToast(data.message);
    } catch (error) {
      reportError(error);
    } finally {
      setLoading(false);
    }
  }

  async function getProvidersStatuses() {
    try {
      setLoading(true);
      const statusesData = await getLocationProviderStatuses(id);

      setStatuses(statusesData.data.data);

      setLoading(false);
    } catch (error) {
      reportError(error);
      setLoading(false);
    }
  }

  useEffect(() => {
    getLocationDetails();
    getProvidersStatuses();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date]);

  const onAddBrandSuccess = (brand: Brand | null) => {
    setAddBrandModal(false);
    setAddBrandSuccessModal(brand);
  };

  const onAddBrandWithTemplateSuccess = (brand: Brand | null) => {
    setBrandTemplates(false);
    setAddBrandSuccessModal(brand);
  };

  const onCreateNonVGrubsBrand = () => {
    setBrandTemplates(false);
    setAddBrandModal(true);
  };

  const locationAddress = `${showStringIfNotNull(
    addressWithUnitNumber(data?.address, data?.unitNumber),
    true
  )} ${showStringIfNotNull(data?.city, true)}  ${showStringIfNotNull(
    data?.state
  )} ${showStringIfNotNull(data?.zipCode, true)} ${showStringIfNotNull(
    data?.country
  )}`;

  const { invalidateByPrefix, invalidateByKey } = useInvalidateQueries();

  // Missing data and system problems are admin and support's to chase;
  // anyone else would get a 403 for both routes.
  const canSeeInsights = role === 'admin' || role === 'support';

  const openOwner = () => {
    if (!data) return;
    navigate(`/users/${data.owner.id}`, {
      state: {
        ...data.owner,
        phoneNumber: data.owner.phone.number,
      },
    });
  };

  // Agents/earning-plans data lives here so editing Services can refetch it
  // (changing services re-splits/empties the per-service agent lists on the BE).
  const agentsApi = useLocationAgents(id, setLoading);

  const handleVDriveOnClick = (status: VDriveStatus | undefined) => {
    navigate(`/locations/v-drive/${id}`, { state: data });
  };

  const actions = [
    {
      label: 'Edit Location',
      onClick: () => setEditLocationModal(true),
      Icon: DropdownLocationIcon,
      disabled: data?.deleted,
    },
    {
      label: 'Manage Providers',
      onClick: () => navigate(`/locations/manage-providers/${id}`),
      Icon: DropdownProvidersIcon,
      disabled: data?.deleted,
    },
    {
      label: 'Integration Access',
      onClick: () => setIntegrationModal(true),
      Icon: DropdownAccessIcon,
      disabled: data?.deleted,
    },
    {
      label: 'Manage vDrive',
      onClick: () => handleVDriveOnClick(data?.vDriveStatus),
      Icon: DropdownVDriveIcon,
      disabled: data?.deleted,
    },
    {
      label: 'Manage Menu',
      onClick: () =>
        navigate(`/menu/${id}/location/0/brand`, {
          state: { name: data?.name },
        }),
      Icon: DropdownMenuIcon,
      disabled: data?.deleted,
    },
    {
      label: 'Edit Notes',
      onClick: () => setNoteModal(true),
      Icon: DropdownNotesIcon,
      disabled: data?.deleted,
    },
    {
      label: 'Sync Providers',
      onClick: () => syncProviders(),
      Icon: DropdownSyncIcon,
      disabled: data?.deleted,
    },
    {
      label: 'Provider Commissions',
      onClick: () => setProviderCommissions(true),
      Icon: DropdownCommissionsIcon,
      disabled: data?.deleted,
    },
    {
      // Menus read their taxes from here, so support needs it as much as
      // admin does; every other role in this app would only get a 403.
      label: 'Tax Rates',
      onClick: () => setTaxRatesModal(true),
      Icon: TaxRatesIcon,
      disabled: data?.deleted,
      show: role === 'admin' || role === 'support',
    },
    {
      // The Menulytics routes are admin and support only.
      label: 'Analyze with Menulytics',
      onClick: () => setMenuHealthModal(true),
      // Their logo, not an icon of ours: it is a partnership with them.
      Icon: (_props: { color?: string }) => <MenulyticsMark />,
      disabled: data?.deleted,
      show: role === 'admin' || role === 'support',
    },
    {
      label: 'Orders',
      onClick: () => navigate(`/orders?locationIds=${id}`),
      Icon: OrderIcon,
      disabled: data?.deleted,
    },
    {
      label: 'Deliveries',
      onClick: () => navigate(`/deliveries?locationIds=${id}`),
      Icon: DeliveriesIcon,
      disabled: data?.deleted,
    },
    {
      label: 'Working Hours',
      onClick: () => navigate(`/working-hours?locationIds=${id}`),
      Icon: WorkingHoursIcon,
      disabled: data?.deleted,
    },
    {
      label: 'Closing Days',
      onClick: () => navigate(`/closing-days?locationIds=${id}`),
      Icon: ClosingDaysPageIcon,
      disabled: data?.deleted,
    },
    {
      label: 'Send Shipment Link',
      onClick: () => setTrackingSmsModal(true),
      Icon: PaperPlaneIcon,
      disabled: data?.deleted,
    },
    {
      label: data?.deleted ? 'Recover Location' : 'Delete Location',
      onClick: () => {
        if (data?.deleted) {
          setRecoverModal(data);
        } else {
          setDeleteModal(id);
        }
      },
      Icon: data?.deleted ? RecoverIcon : DropdownDeleteIcon,
      show: role === 'admin' || role === 'support',
      color: lightTheme.primary,
    },
  ];

  return (
    <>
      {loading && <AdminSpinner />}
      <AdminHeader title="Location Details">
        <Div $flex $alignCenter $gap="32px" $gapSM="16px">
          <AdminOptionsDropdown actions={actions} />
        </Div>
      </AdminHeader>
      {data && (
        <Div>
          <Div
            $m="32px 0"
            $mSM="20px 0"
            $flex
            $alignCenter
            $between
            $columnSM
            $gap="30px"
          >
            <Div $flex $alignCenter $gap="30px" $gapSM="16px" $widthSM="100%">
              <LocationImage imageUrl={data.imageUrl} size={125} />
              <Div $flex $column $gap="4px">
                <H3 $m="0" $color={lightTheme.primary}>
                  {data.name}
                </H3>
                <P $m="0">{locationAddress}</P>
                {data.phone && <PhoneNumberText phone={data.phone} />}
                <CopyTextWithIcon
                  text={`Store ID: ${data.storeId}`}
                  copy={data.storeId.toString()}
                />
                <LocationReferralInfo
                  locationId={id}
                  locationName={data.name}
                />
                <Div>
                  <RenderProviderStatus statuses={statuses} />
                </Div>
                <Div>
                  <Pill $background={lightTheme.primary}>
                    <Disclaimer $m="0" $color={lightTheme.white} $uppercase>
                      {data.mode}
                    </Disclaimer>
                  </Pill>
                </Div>
                {data.deleted && (
                  <div>
                    <Pill $background={lightTheme.darkGray}>
                      <Disclaimer $m="0" $color={lightTheme.white}>
                        Inactive
                      </Disclaimer>
                    </Pill>
                  </div>
                )}
              </Div>
            </Div>
          </Div>
          {data.outstanding && (
            <Div $m="0 0 32px" $mSM="0 0 20px">
              <OutstandingBalanceBanner
                locationId={data.id}
                outstanding={data.outstanding}
              />
            </Div>
          )}
          {canSeeInsights && (
            <LocationProblems
              locationId={id}
              onAction={(action) =>
                action === 'bankDetails' ? setEditBankModal(true) : openOwner()
              }
              // "Open SaaS settings" is this screen's own services modal:
              // open it here, through the same flag the deep link sets.
              onOpenServices={() => {
                searchParams.set('editServices', '1');
                setSearchParams(searchParams, { replace: true });
              }}
            />
          )}
          <TopCards>
            <OwnerComponent
              title={'Owner'}
              owner={data.owner}
              onClick={openOwner}
            />
            <Earnings
              referral={data.referral}
              setLoading={setLoading}
              id={id}
              agentsApi={agentsApi}
            />
            <ServicesCell>
              <Services
                setLoading={setLoading}
                id={id}
                salesConfig={data.salesConfig}
                setData={setData}
                label="Services in use"
                componentText={`Services that client is currently using`}
                onServicesUpdated={() => agentsApi.refetch(true)}
                openRequested={searchParams.has('editServices')}
                onOpenHandled={() => {
                  searchParams.delete('editServices');
                  setSearchParams(searchParams, { replace: true });
                }}
              />
            </ServicesCell>
          </TopCards>
          <Div
            $m="24px 0"
            // On a phone the two boxes stack: keep them close to each other
            // and leave the air below, before Overview.
            $mSM="8px 0 24px"
            $flex
            // `$reverseSM` used to stack these on a phone, with the right box
            // on top; plain column keeps the payouts above the taxes.
            $columnSM
            $gap="24px"
            $gapSM="8px"
          >
            <AmountsMain>
              <AmountsPanel>
                {ensurePayoutConfigs(data.payoutConfigs)
                  .filter((config) => isPayoutServiceVisible(config.service))
                  .map((config) => (
                    <AmountComponent
                      key={config.service}
                      amount={describePayoutConfig(config)}
                      subtitle={payoutModelLabel(config.model)}
                      title={payoutServiceLabel(config)}
                      onClick={() => setPayoutConfigModal(config)}
                    />
                  ))}
              </AmountsPanel>
            </AmountsMain>
            <AmountsAside>
              <LocationTaxRatesSummary
                locationId={id}
                mode={data.mode}
                setLoading={setLoading}
                onManage={() => setTaxRatesModal(true)}
              />
            </AmountsAside>
          </Div>

          <LocationAnalyticsSection
            data={data}
            showServiceValue={canSeeInsights}
          />

          <Div $mb="16" $flex $between $alignCenter>
            <H5 $m="0">Brands</H5>
            <Icon $pointer onClick={() => setBrandTemplates(true)}>
              <PlusIcon />
            </Icon>
          </Div>

          {data.brands.length === 0 ? (
            <P $m="40px 0" $center>
              No brands
            </P>
          ) : (
            <DragScrollX width="22%" widthMD="22%">
              {data.brands.map((brand, i) => {
                return (
                  <BrandLocationComponent
                    key={i}
                    brand={brand}
                    isPos={data.mode === LocationMode.pos}
                  />
                );
              })}
            </DragScrollX>
          )}

          {/* What the tablet last reported about its printers - where a
              printerError system problem sends support. */}
          <LocationPrinters locationId={id} />

          <Div $mb="16" $flex $between $alignCenter>
            <H5 $m="0">Bank Details</H5>
            <Icon $pointer onClick={() => setEditBankModal(true)}>
              <EditPenIconRed />
            </Icon>
          </Div>

          <Div $flex $columnSM $gap="40px" $gapSM="8px" $width="100%" $mb="40">
            <Box $flex $alignCenter $between $width="50%" $widthSM="100%">
              <P $m="0">Last 4 EIN:</P>
              <P $m="0">{data.configuration.einLast4}</P>
            </Box>
            <Box $flex $alignCenter $between $width="50%" $widthSM="100%">
              <P $m="0">Last 4 Bank:</P>
              <P $m="0">{data.configuration.bankAccountLast4}</P>
            </Box>
          </Div>

          <H5 $mb="16">Voided Check</H5>
          {data.images.length === 0 ? (
            <P $m="40px 0" $center>
              No voided checks
            </P>
          ) : (
            <DragScrollX width="22%">
              {data.images.map((img, i) => {
                return (
                  <Div key={i} $width="22%">
                    <ImageWithDownload key={i} src={img.url} />
                  </Div>
                );
              })}
            </DragScrollX>
          )}

          {/* Read only here: the owner uploads it at sign up and replaces it
              from Settings. Older locations may have none. */}
          <H5 $m="40px 0 16px">Business License</H5>
          {data.businessLicense ? (
            <Div $width="22%" $widthSM="100%">
              <ImageWithDownload src={data.businessLicense} lightbox />
            </Div>
          ) : (
            <P $m="40px 0" $center>
              No business license uploaded
            </P>
          )}

          <BrandAddModal
            setLoading={setLoading}
            modalIsOpen={addBrandModal}
            closeModal={() => {
              setAddBrandModal(false);
            }}
            onAddBrandSuccess={onAddBrandSuccess}
            setData={setData}
            data={data}
            type="add"
          />

          <TemplateBrandAdd
            modalIsOpen={brandTemplates}
            closeModal={() => {
              setBrandTemplates(false);
            }}
            onAddBrandSuccess={onAddBrandWithTemplateSuccess}
            setData={setData}
            data={data}
            onCreateNonVGrubsBrand={onCreateNonVGrubsBrand}
          />

          <BrandAddSuccessModal
            modalIsOpen={addBrandSuccessModal}
            closeModal={() => {
              setAddBrandSuccessModal(null);
            }}
          />

          <BrandNoteModal
            closeModal={() => {
              setNoteModal(false);
            }}
            modalIsOpen={noteModal}
            setLoading={setLoading}
            setData={setData}
            data={data}
            pathPrefix="locations"
          />

          <IntegrationAccessModal
            modalIsOpen={integrationModal}
            closeModal={() => setIntegrationModal(false)}
            locationId={id}
          />
        </Div>
      )}

      <PayoutConfigModal
        modalIsOpen={!!payoutConfigModal}
        closeModal={() => setPayoutConfigModal(null)}
        locationId={id}
        config={payoutConfigModal}
        readOnly={role !== 'admin'}
        onSaved={() => getLocationDetails(true)}
      />

      <LocationEdit
        setLoading={setLoading}
        modalIsOpen={editLocationModal}
        closeModal={() => {
          setEditLocationModal(false);
        }}
        getData={getLocationDetails}
        data={data}
        setChangeAddressModal={setChangeAddressModal}
      />
      <BankEdit
        setLoading={setLoading}
        modalIsOpen={editBankModal}
        closeModal={() => {
          setEditBankModal(false);
          // The EIN, the bank's last 4 and the voided check are all edited
          // here, and each may be a missing item: ask again once it closes.
          invalidateByKey(queryKeys.locationInsights.alerts(id));
        }}
        setData={setData}
        data={data}
      />
      <DeleteLocationBrandModal
        isOpen={deleteModal}
        closeModal={() => {
          setDeleteModal(null);
        }}
        setLoading={setLoading}
        type={'locations'}
      />
      <UsersAndAccessDetailsModal
        modalIsOpen={userDetailsModal}
        closeModal={() => {
          setUserDetailsModal(null);
        }}
        noActions
        callGetUser
      />
      <AllProvidersModalComponent
        allProvidersModal={allProvidersModal}
        setAllProvidersModal={setAllProvidersModal}
      />
      <ChangeLocationAddress
        modalIsOpen={changeAddressModal}
        closeModal={() => {
          setChangeAddressModal(false);
        }}
        setLoading={setLoading}
        setConfirmAddressModal={setConfirmAddressModal}
        currentUnitNumber={data?.unitNumber}
      />

      <ChangeLocationAddressConfirm
        modalIsOpen={confirmAddressModal}
        closeModal={() => {
          setConfirmAddressModal(null);
        }}
        setDetails={setConfirmAddressModal}
        setLoading={setLoading}
        setData={setData}
      />

      <LocationTaxRatesModal
        taxRatesModal={taxRatesModal}
        closeModal={() => setTaxRatesModal(false)}
        locationId={id}
        mode={data?.mode}
        setLoading={setLoading}
      />

      <ProviderCommissionsModal
        modalIsOpen={providerCommissions}
        closeModal={() => setProviderCommissions(false)}
        setLoading={setLoading}
        setData={setData}
        data={data}
      />

      <SendTrackingSmsModal
        modalIsOpen={trackingSmsModal}
        closeModal={() => setTrackingSmsModal(false)}
        setLoading={setLoading}
        locationId={id}
      />

      <MenuHealthReportsModal
        isOpen={menuHealthModal}
        closeModal={() => setMenuHealthModal(false)}
        locationId={id}
        locationName={data?.name}
        brands={data?.brands}
      />

      <LocationRecoverModal
        setLoading={setLoading}
        modalIsOpen={recoverModal}
        closeModal={() => setRecoverModal(null)}
        onSuccess={() => {
          setRecoverModal(null);
          getLocationDetails(true);
          invalidateByPrefix('/v1/locations/verified');
        }}
      />
    </>
  );
};

const OwnerComponent = ({ owner, title, onClick }) => {
  return (
    <Box $flex $between $alignCenter $gap="20px">
      <Div $minWidth="0">
        <P $mb="4">{title}</P>
        <H5 $mb="0">
          {owner.firstName} {owner.lastName}
        </H5>
      </Div>
      {onClick && (
        <Icon $pointer onClick={onClick}>
          <ArrowRed />
        </Icon>
      )}
    </Box>
  );
};

/**
 * Owner, Agents and Services. Each card starts at 300px and grows, so with the
 * sidebar open and no room for three the Services card wraps under the other
 * two at full width instead of all three getting squeezed. The gap is the one
 * the payout and tax boxes below use, so the two rows line up.
 */
const TopCards = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  margin: 24px 0;

  > * {
    flex: 1 1 300px;
    min-width: 0;
  }

  @media (max-width: 800px) {
    gap: 8px;
    margin: 8px 0;
  }
`;

/**
 * Services is the one card in the row that comes wrapped, and a plain block
 * wrapper let it keep its content height while Owner and Agents were stretched
 * by the row. Flex here, full width on the card, so all three end up the same
 * height.
 */
const ServicesCell = styled.div`
  display: flex;

  > div {
    width: 100%;
  }
`;
